import queryString from "query-string";
import type { NskResponse } from "~/models/Api";
import type { ConstructionItemSettingEdit } from "~/models/ConstructionItemSetting";
import { postRequest } from "../api_handler";

const paths = {
	create: "/vendors/construction_item_settings/"
};

export const create = async (
	constructionItemSettings: ConstructionItemSettingEdit[],
	companyMasterId: number
): Promise<NskResponse> =>
	postRequest(
		queryString.stringifyUrl({
			query: { company_master_id: companyMasterId },
			url: paths.create
		}),
		{
			constructionItemSettings
		}
	);
